module.exports = __webpack_public_path__ + "static/media/whatsapp.4aa10af1.png";